import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

import { QuoteRequestFilesModal } from "#modules/quoteRequestsV2/view/organisms/QuoteRequestFilesModal";
import { ROUTES } from "#shared/routes";

type Props = {
  opened: boolean;
  onClose: () => void;
};

export const CreateQuoteRequestModal = ({ opened, onClose }: Props) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <QuoteRequestFilesModal
      opened={opened}
      onClose={onClose}
      title={t("quoteRequestsV2.modal.title")}
      primaryText={t("quoteRequestsV2.modal.next")}
      onNext={(quoteRequestId) => navigate(ROUTES.v2QuoteRequest(quoteRequestId))}
    />
  );
};
